import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

/** A Cloud Functions callable by name; calling it resolves the function's returned data. */
export const call = (name) => async (data) => (await httpsCallable(functions, name)(data)).data;
